/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    VoucherProduct,
    VoucherProductFromJSON,
    VoucherProductToJSON,
    VoucherProductDataFrame,
    VoucherProductDataFrameFromJSON,
    VoucherProductDataFrameToJSON,
} from '../models';

export interface ApiVoucherProductsGetRequest {
    relations?: string;
    deleted?: boolean;
    filtering?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface ApiVoucherProductsIdDeleteRequest {
    id: number;
}

export interface ApiVoucherProductsIdGetRequest {
    id: number;
    relations?: string;
    deleted?: boolean;
}

export interface ApiVoucherProductsPostRequest {
    relations?: string;
    deleted?: boolean;
    voucherProduct?: VoucherProduct;
}

/**
 * no description
 */
export class VoucherProductApi extends runtime.BaseAPI {

    /**
     * Get list of VoucherProduct
     */
    async apiVoucherProductsGetRaw(requestParameters: ApiVoucherProductsGetRequest): Promise<runtime.ApiResponse<VoucherProductDataFrame>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        if (requestParameters.filtering !== undefined) {
            queryParameters['filtering'] = requestParameters.filtering;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/voucherProducts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VoucherProductDataFrameFromJSON(jsonValue));
    }

    /**
     * Get list of VoucherProduct
     */
    async apiVoucherProductsGet(relations?: string, deleted?: boolean, filtering?: string, offset?: number, limit?: number, order?: string): Promise<VoucherProductDataFrame> {
        const response = await this.apiVoucherProductsGetRaw({ relations: relations, deleted: deleted, filtering: filtering, offset: offset, limit: limit, order: order });
        return await response.value();
    }

    /**
     * Remove entity of VoucherProduct
     */
    async apiVoucherProductsIdDeleteRaw(requestParameters: ApiVoucherProductsIdDeleteRequest): Promise<runtime.ApiResponse<VoucherProduct>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiVoucherProductsIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/voucherProducts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VoucherProductFromJSON(jsonValue));
    }

    /**
     * Remove entity of VoucherProduct
     */
    async apiVoucherProductsIdDelete(id: number): Promise<VoucherProduct> {
        const response = await this.apiVoucherProductsIdDeleteRaw({ id: id });
        return await response.value();
    }

    /**
     * Get entity of VoucherProduct
     */
    async apiVoucherProductsIdGetRaw(requestParameters: ApiVoucherProductsIdGetRequest): Promise<runtime.ApiResponse<VoucherProduct>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiVoucherProductsIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/voucherProducts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VoucherProductFromJSON(jsonValue));
    }

    /**
     * Get entity of VoucherProduct
     */
    async apiVoucherProductsIdGet(id: number, relations?: string, deleted?: boolean): Promise<VoucherProduct> {
        const response = await this.apiVoucherProductsIdGetRaw({ id: id, relations: relations, deleted: deleted });
        return await response.value();
    }

    /**
     * Create or update entity of VoucherProduct (if id defined)
     */
    async apiVoucherProductsPostRaw(requestParameters: ApiVoucherProductsPostRequest): Promise<runtime.ApiResponse<VoucherProduct>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/voucherProducts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VoucherProductToJSON(requestParameters.voucherProduct),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VoucherProductFromJSON(jsonValue));
    }

    /**
     * Create or update entity of VoucherProduct (if id defined)
     */
    async apiVoucherProductsPost(relations?: string, deleted?: boolean, voucherProduct?: VoucherProduct): Promise<VoucherProduct> {
        const response = await this.apiVoucherProductsPostRaw({ relations: relations, deleted: deleted, voucherProduct: voucherProduct });
        return await response.value();
    }

}
